import { getBrowserLocales } from 'services/getBrowserLocales';

export const SUPPORTED_LOCALES = ['en-US', 'en-CA', 'fr-CA'];

export const getCurrencySymbol = (currency: string): string => {
  const browserLocales = getBrowserLocales();

  try {
    const locale =
      !!browserLocales?.[0] && SUPPORTED_LOCALES.includes(browserLocales?.[0])
        ? browserLocales?.[0]
        : 'en-US';

    return (
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol',
      })
        .formatToParts(0)
        .find((part) => part.type === 'currency')?.value || '$'
    );
  } catch (error) {
    // Fallback to $ if currency formatting fails
    return '$';
  }
};

export const SUPPORTED_CURRENCIES = ['USD', 'CAD'];
